import React, { useState } from 'react';
import { sessionLogin, setToken } from '../api.js';

function SessionLogin({ sessionType, onSuccess, onBack }) {
  const [teamNumber, setTeamNumber] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const title = sessionType === 'official' ? 'Online Quiz Sign In' : 'Dry Run Sign In';

  async function submit(event) {
    event.preventDefault();
    const normalizedTeamNumber = teamNumber.trim().toUpperCase();
    const normalizedPhone = phoneNumber.replace(/\D/g, '').slice(0, 10);
    if (!normalizedTeamNumber || !/^[6-9]\d{9}$/.test(normalizedPhone)) {
      setError('Enter your team number and a registered 10-digit participant mobile number.');
      return;
    }
    setError('');
    setLoading(true);
    try {
      const data = await sessionLogin(normalizedTeamNumber, normalizedPhone, sessionType);
      setToken(data.token);
      onSuccess(data);
    } catch (requestError) {
      setError(requestError.message || 'Unable to sign in.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-overlay">
      <div className="login-card session-login-card">
        <img src="/napcon_logo2.jpeg" alt="NAPCON 2026" className="napcon-logo" />
        <h2>{title}</h2>
        <p>Sign in using your team number and the registered mobile number of either participant.</p>
        <form className="login-form" onSubmit={submit}>
          <div className="form-group">
            <label>Team number</label>
            <input type="text" value={teamNumber} onChange={(event) => setTeamNumber(event.target.value.toUpperCase())} placeholder="NAP-KOL-123" autoComplete="off" required />
          </div>
          <div className="form-group">
            <label>Mobile number</label>
            <input type="tel" value={phoneNumber} onChange={(event) => setPhoneNumber(event.target.value.replace(/\D/g, '').slice(0, 10))} inputMode="numeric" maxLength="10" autoComplete="tel" required />
          </div>
          {error && <div className="error-message">{error}</div>}
          <button type="submit" className="submit-btn" disabled={loading}>{loading ? 'Signing in...' : 'Start Quiz'}</button>
          <button type="button" className="text-button" onClick={onBack} disabled={loading}>Back</button>
        </form>
      </div>
    </div>
  );
}

export default SessionLogin;
